angular.module('TetherApp').controller('JobReportingController', [
    'jobApiService',
    function (jobApiService) {

        let ctrl = this;
        this.jobs = [];

        let onJobs = function (data) {
            if (ctrl.jobs !== undefined && ctrl.jobs.length > 0) {
                //Remove pre-existing array values
                for (let dataKey in data) {
                    for (let jobsKey in ctrl.jobs) {
                        if (data[dataKey]['id'] == ctrl.jobs[jobsKey]['id']) {
                            data.splice(dataKey, 1);
                        }
                    }
                }
                ctrl.jobs = ctrl.jobs.concat(data);
            } else {
                ctrl.jobs = data;
            }
        };

        let onError = function(reason) {
            ctrl.error = 'Could not fetch the data.';
        };

        this.fetchJobs = function() {
            jobApiService.getJobs()
                .then(onJobs, onError);
        };
        setInterval(this.fetchJobs, 500);

    }
]);
